import { captureMessage } from '@sentry/browser';
import React from 'react';
import { AssetDownscaleStatuses } from '../../../../../common/src/domain/asset/assetDownscaleStatuses';
import { useTranslate } from '../../../mixins/translate/translate';
import { fetchGet } from '../../../store/fetch';
import { AssetTypes } from '../../../utils/enums/AssetTypes';
import { formatBytes } from '../../../utils/formatBytes';
import { formatTimestamp } from '../../../utils/formatTimestamp';
import { PanelHeading, PanelWithoutForm, Table, TableBody, TableData, TableHead, TableHeader, TableHeadRow, TableRow } from '../../elements';
import { Spinner } from '../../spinners';
import { NullableFormattedDate } from '../../utils/NullableFormattedDate';
import { useReactAsync } from '../../utils/useReactAsync';
import { IAsset } from '../Interfaces/IAsset';

async function loadVideos({ surveyId }: { surveyId: string }) {
    const queryString = {
        surveyId,
        types: AssetTypes.SurveyVideo,
    };
    const result = await fetchGet('/api/assets', queryString, ['404']);
    return result.json as IAsset[];
}

const openAsset = (asset: IAsset) => {
    if (asset.downscaleStatusHigh && asset.downscaleStatusHigh === AssetDownscaleStatuses.Complete) {
        window.open(`/api/assets/${asset.id}/download?downscaledHigh=true`);
    } else if (asset.downscaleStatusLow && asset.downscaleStatusLow === AssetDownscaleStatuses.Complete) {
        window.open(`/api/assets/${asset.id}/download`);
    } else {
        console.log('Nothing to open');
    }
};

const downloadAsset = (asset: IAsset) => {
    // TODO: ZXY-1209 clean up if bug is fixed
    if (!window?.location?.href) {
        captureMessage('window.location.href is undefined');
    }
    if (asset.downscaleStatusHigh && asset.downscaleStatusHigh === AssetDownscaleStatuses.Complete) {
        window.location.href = `/api/assets/${asset.id}/download?downscaledHigh=true&forceDownload=true`;
    } else if (asset.downscaleStatusLow && asset.downscaleStatusLow === AssetDownscaleStatuses.Complete) {
        window.location.href = `/api/assets/${asset.id}/download&forceDownload=true`;
    } else {
        console.log('Nothing to download');
    }
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const VideoList = (props: { surveyId: string }) => {
    const translate = useTranslate();
    const { data, isLoading } = useReactAsync(loadVideos, { surveyId: props.surveyId }, []);

    return (
        <PanelWithoutForm id="Videos">
            <PanelHeading text={translate('video.videos')} icon="fa fa-film" />
            {(isLoading && <Spinner />) || (
                <Table hover>
                    <TableHead>
                        <TableHeadRow light={true}>
                            <TableHeader>{translate('common.filename')}</TableHeader>
                            <TableHeader>{translate('common.size')}</TableHeader>
                            <TableHeader>{translate('common.duration')}</TableHeader>
                            <TableHeader>{translate('common.date')}</TableHeader>
                            <TableHeader>Download</TableHeader>
                        </TableHeadRow>
                    </TableHead>
                    <TableBody>
                        {data &&
                            data.map((asset) => (
                                <TableRow key={asset.id} onClick={() => openAsset(asset)}>
                                    <TableData>{asset.name}</TableData>
                                    <TableData>{formatBytes(asset.size)}</TableData>
                                    <TableData>{asset.duration ? formatTimestamp(asset.duration) : '-'}</TableData>
                                    <TableData>
                                        <NullableFormattedDate value={asset.date} />
                                    </TableData>
                                    <TableData>
                                        <a
                                            href="#"
                                            onClick={(e) => {
                                                e.preventDefault();
                                                e.stopPropagation();
                                                downloadAsset(asset);
                                            }}
                                        >
                                            <span className="fa fa-download" />
                                        </a>
                                    </TableData>
                                </TableRow>
                            ))}
                    </TableBody>
                </Table>
            )}
        </PanelWithoutForm>
    );
};
